import { NOT_AVAILABLE } from 'core/constants';
import { ICorporateLocationAutocomplete } from 'corporate/types';

export const getInventoryShippingLocationLabel = (
  location: ICorporateLocationAutocomplete | null
): string => {
  if (!location) {
    return '';
  }

  return [location.name || NOT_AVAILABLE, location.vendorId ? `(${location.vendorId})` : '']
    .filter(Boolean)
    .join(' ');
};
